/**
 * A collection of string utilities used for the project.
 */

export const QUESTION_MARK = '?';
export const FORWARD_SLASH = '/';

export const prependQuestionMark = (string) => {
    return QUESTION_MARK + string;
};

export const prependForwardSlash = (string) => {
    return FORWARD_SLASH + string;
};

/**
 * Appends either 's or just ' to the back of a
 * {@param string} to show possession.
 *
 * {@example I am appendPossessionApostrophe('Jack') colon.
 *      I get cancer, I kill Jack.
 * }
 */
export const appendPossessionApostrophe = (string) => {
    if (!string || string === '')
        return string;
    else if (string.charAt(string.length - 1) === 's')
        return string + "'";
    else
        return string + "'s";
};

/**
 * Removes leading and trailing quotation marks (")
 * from a given {@param string}.
 */
export const removeLeadingAndTrailingQuotations = (string) => {
    return string.replace(/(^")|("$)/g, "");
};

/**
 * Wraps a {@param string} around quotation marks (")
 */
export const wrapAroundQuotations = (string) => {
    return '"' + string + '"';
};

/**
 * Returns the Levenshtein distance between two strings
 * {@param a} and {@param b}.
 *
 * {@author http://rosettacode.org/wiki/Levenshtein_distance}
 */
export const levenshteinDistance = (a, b) => {
    a = a.toLowerCase();
    b = b.toLowerCase();
    let t = [], u, i, j, m = a.length, n = b.length;
    if (!m) { return n; }
    if (!n) { return m; }
    for (j = 0; j <= n; j++) { t[j] = j; }
    for (i = 1; i <= m; i++) {
        for (u = [i], j = 1; j <= n; j++) {
            u[j] = a[i - 1] === b[j - 1] ? t[j - 1] : Math.min(t[j - 1], t[j], u[j - 1]) + 1;
        } t = u;
    } return u[n];
};



// WEBPACK FOOTER //
// ./src/utils/string.js